var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeadComponent',{attrs:{"msg":"Welcome to Your Vue.js App"}}),_c('el-main',[_c('div',[_vm._v(" 未輸入問卷網址ID ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }